import { RouteConfig } from 'vue-router';
const Folder = () => import('./views/folder.vue');
const ConsultManage = () => import('./views/consult-manage.vue');
const Resources = () => import('./views/resources.vue');
const routers: RouteConfig[] = [
    {
        path: 'folder',
        name: 'folder',
        component: Folder
    },
    {
        path: 'consult-manage',
        name: 'consult-manage',
        component: ConsultManage
    },
    {
        path: '',
        redirect: 'folder'
    },
];
export default routers;

